import { ZOOM_11, ZOOM_13 } from '@/utils/constants/map';

export const getNextZoomBucket = (zoom: number): number => {
  if (zoom >= ZOOM_13) {
    return ZOOM_13;
  }

  if (zoom >= ZOOM_11) {
    return ZOOM_11;
  }

  return 0;
};
